import { Layer, Source } from 'react-map-gl/maplibre'
import { useAppStore } from '~/hooks'
import { VisibleLayers } from '~/constants'
import { BATHYMETRY_COG_URL, PMTileURLs } from '~/constants'

export function BathymetryLayer() {
  const { layerVisibility, dataset } = useAppStore()
  const visible = dataset === 'waves' && layerVisibility[VisibleLayers.BATHYMETRY]
  return (
    <>
      <Source
        id="bathymetry-dem"
        type="raster-dem"
        url={`pmtiles://${PMTileURLs.bathymetry}`}
        encoding="terrarium"
        tileSize={512}
      >
        <Layer
          id="bathymetry-hillshade"
          type="hillshade"
          source="bathymetry-dem"
          layout={{ visibility: visible ? 'visible' : 'none' }}
          paint={{ 'hillshade-exaggeration': 0.5 }}
        />
      </Source>
      <Source id="bathymetry-raster" type="raster" url={`cog://${BATHYMETRY_COG_URL}`}>
        <Layer
          id="bathymetry-color"
          type="raster"
          source="bathymetry-raster"
          layout={{ visibility: visible ? 'visible' : 'none' }}
          paint={{ 'raster-opacity': 0.6 }}
        />
      </Source>
    </>
  )
}
